<template>
  <div class="spl-subheader-login">
    <form @submit.prevent="submit">
      <div class="row">
        <div class="col3 sm-col12 spl-subheader-login__heading">
          <strong>Login</strong> with your time:matters <br>credentials
        </div>
        <div class="col2" />
        <div class="col3 xl-col2 sm-col12">
          <form-input
            ref="username"
            v-model="credentials.username"
            :invalid="$v.credentials.username.$error"
            placeholder="Username"
            type="email"
            autocomplete="username"
            @blur="$v.credentials.username.$touch()" />
          <span v-if="$v.credentials.username.$error && !$v.credentials.username.required" class="error">Username is required</span>
          <span v-if="$v.credentials.username.$error && !$v.credentials.username.email" class="error">Username has do be an E-Mail</span>
        </div>
        <div class="col3 xl-col2 sm-col12">
          <form-input
            ref="password"
            v-model="credentials.password"
            :invalid="$v.credentials.password.$error"
            placeholder="Password"
            autocomplete="current-password"
            type="password"
            @blur="$v.credentials.password.$touch()" />
          <div class="spl-subheader-login__link" @click="openRecoverPasswordModal">
            Recover password
          </div>
          <span v-if="$v.credentials.password.$error && !$v.credentials.password.required" class="error">Password is required</span>
        </div>
        <div class="col1 sm-col12">
          <form-button
            :disabled="$v.$error || isLoading"
            primary="true"
            wide="true">
            Login
          </form-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'SubheaderLogin',
  data () {
    return {
      // We need to initialize the component with any
      // properties that will be used in it
      credentials: {
        username: '',
        password: '',
        grant_type: 'password'
      },
      error: '',
      loginErrorMessage: '',
      isLoading: false
    }
  },
  validations: {
    credentials: {
      username: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    // Login function
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      // Databinding not working for Firefox and Edge Autofill
      this.credentials.username = this.$refs.username.$el.value
      this.credentials.password = this.$refs.password.$el.value
      var forwardPath = this.$route.query.forwardPath || ''
      this.isLoading = true
      this.login({
        username: this.credentials.username,
        password: this.credentials.password,
        redirect: forwardPath + '?newly_logged_in=true'
      }).then(() => {
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    mounted () {
      this.$refs.username.trigger('change')
      this.$refs.password.trigger('change')
      this.$v.credentials.username.$touch()
      this.$v.credentials.password.$touch()
    },
    // Open recoverPasswordModal
    openRecoverPasswordModal () {
      window.bus.$emit('openRecoverPasswordModal')
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";
.spl-error-message {
  position: absolute;
  right: 10px;
}
.spl-subheader-login {
  position: relative;
  background-color: $yellowButtonLabelHover;
  color: $headerLatestUpdatesDateColor;
  font-weight: 600;
  height: 140px;
  margin-bottom: 60px;
  padding: 40px $mainPadding;
  width: 100%;

  @include mobile() {
    height: 280px;
    padding: $mobilePadding;

    &__heading {
      margin-bottom: 5px;

      br {
        display: none;
      }
    }
  }
  strong {
    color: $headerLatestUpdatesLabelColor;
  }
  .spl-input {
    margin-bottom: 0;

    @include mobile() {
      margin-bottom: 10px;
    }
  }
  &__link {
    color: $disabledYellow;
    cursor: pointer;
    float: right;
    font-size: 12px;
    padding: 5px 0;
    transition: color $shortTransition ease-in-out;

    &:hover {
      color: $middleYellow;
    }
  }
}
</style>
